module.exports = __webpack_public_path__ + "static/media/crew-m-3.04545508.png";